import React from "react";
import { MedicationDecisionResult } from "../../../../../../data-model/cmmOrderTableRowData";
import NewDetailsCard from "../../../../../newDetailsCard/newDetailsCard";
import { DecisionReasonBar, StatusBadge } from "./medicationLogicElements";

interface DecisionDetailsCardProps {
  decision: MedicationDecisionResult;
}

const DecisionDetailsCard: React.FC<DecisionDetailsCardProps> = ({
  decision,
}) => (
  <div className="rounded-xl bg-white p-4">
    <div className="mb-4 flex items-center justify-between">
      <div className="text-sm font-bold text-primaryGray-1">
        Decision Status
      </div>
      <StatusBadge status={decision.decision_status} />
    </div>
    <DecisionReasonBar reason={decision.decision_reason} />
    <div className="mb-4">
      <NewDetailsCard
        header="Attempted Path"
        body={decision.attempted_path || "--"}
      />
    </div>
    <div className="flex flex-wrap gap-y-4">
      <div className="w-1/2">
        <NewDetailsCard
          header="Generic Source"
          body={decision.generic_source || "--"}
        />
      </div>
      <div className="w-1/2">
        <NewDetailsCard
          header="Primary Search Term"
          body={decision.primary_search_term || "--"}
        />
      </div>
      <div className="w-1/2">
        <NewDetailsCard
          header="Fallback Search Term"
          body={decision.fallback_search_term || "--"}
        />
      </div>
      <div className="w-1/2">
        <NewDetailsCard
          header="Fallback Used"
          body={decision.fallback_used ? "Yes" : "No"}
        />
      </div>
    </div>
  </div>
);

export default DecisionDetailsCard;
